import React from 'react';
import { useTranslation } from 'react-i18next';

interface FieldErrorProps {
  message?: string | null;
  id?: string;
  /** Interpolation values for i18n (e.g. max length). */
  values?: Record<string, string | number>;
}

/** Inline validation message below a field (pair with `.form-field--error` on the wrapper). */
const FieldError = ({ message, id, values }: FieldErrorProps): JSX.Element | null => {
  const { t } = useTranslation();
  if (!message) return null;
  return (
    <p id={id} className="form-field-error" role="alert">
      {t(message, values)}
    </p>
  );
};

export default FieldError;
